<template>
  <div :class="{ [$style.toast]: shown }" :style="$store.state.event.themeStyles">
    <div role="status" aria-atomic="true">
      <template v-if="shown">
        <span :class="$style.toastHeader">
          <span v-if="icon" :class="$style.toastIcon">
            <SvgIcon :name="icon" color="theme-secondary-color" />
          </span>
          <StyledText color="theme-secondary-color" variant="heading14">
            {{ title }}
          </StyledText>
        </span>
        <div :class="$style.toastBody">
          <StyledText color="primary-text-color">
            <span :class="$style.messages">
              <template v-for="(part, index) in messageParts" :key="index">
                <a
                  v-if="part.href"
                  :href="part.href"
                  target="_blank"
                  rel="noopener noreferrer"
                  :aria-label="$t('@@translate@@ {linkText} (opens in a new window)', { linkText: part.text })"
                  >{{ part.text }}</a
                >
                <template v-else>{{ part.text }}</template>
              </template>
            </span>
          </StyledText>
        </div>
      </template>
    </div>
    <button
      v-if="shown"
      type="button"
      :class="$style.closeButton"
      :aria-label="$t('@@translate@@ Close notification')"
      @click="close"
    >
      <SvgIcon name="cross" color="primary-text-color" :ariaHidden="true" />
    </button>
  </div>
</template>

<script>
import { SvgIcon } from 'uicomponents';

import { getSafeLinkHref } from '@/utils/url';

export default {
  name: 'Toast',
  components: { SvgIcon },
  props: {
    title: String,
    message: String,
    type: {
      type: String,
      default: 'success'
    },
    icon: String,
    duration: Number,
    variables: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      shown: false
    };
  },
  mounted() {
    setTimeout(() => (this.shown = true), 300);
    if (this.duration) {
      setTimeout(() => {
        this.close();
      }, this.duration);
    }
  },
  computed: {
    messageParts() {
      return this.message.split('*').map((text, index) => {
        const variable = index % 2 === 1 ? this.variables[(index - 1) / 2] : undefined;
        return {
          text,
          href: variable?.type === 'link' ? getSafeLinkHref(variable.value) : undefined
        };
      });
    }
  },
  methods: {
    close() {
      this.shown = false;
      setTimeout(() => {
        this.$emit('cancel');
      }, 300);
    }
  }
};
</script>

<style lang="css" module>
.toast {
  background-color: var(--theme-primary-color);
  border-radius: 16px;
  position: relative;
  margin: 16px 0 0;
  padding: 16px;
}

.toastHeader {
  font-size: 13px;
  line-height: 13px;
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  margin: 0 0 8px;
}

.toastIcon {
  margin-right: 8px;
}

.closeButton {
  appearance: none;
  background: transparent;
  border: 0;
  position: absolute;
  right: 8px;
  top: 8px;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
}

.toastBody {
  font-size: 14px;
  line-height: 14px;
  font-weight: 500 !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.messages a {
  color: var(--theme-secondary-color) !important;
}
</style>
